import { v4 as uuid } from 'uuid';

import { AUDIT_ACTION, TAuditAction, TAuditEvent } from '../models';

// Factory for a single audit event. Every automation and transition records one
// so the prototype's behavior is always visible and reviewable.
export const makeAuditEvent = (actor: string, action: TAuditAction, description: string): TAuditEvent => ({
  id: uuid(),
  timestamp: new Date().toISOString(),
  actor,
  action,
  description,
});

export { AUDIT_ACTION };
